module.exports = __webpack_public_path__ + "img/teppich5.1c4e4af5.png";